import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";

import JobApi from '../../api/JobApi';
import JobRunDto from '../../classes/dtos/jobmodule/JobRunDto';
import RunGrid from '../../components/run-grid/RunGrid';

import PathType from '../../consts/pathmodule/PathType';

import { PathSynchroRoute, PathReportingRoute, PathDataTableRoute, PathMetaApiRoute, PathAIRoute } from '../../app-routes';

import './runs.scss';

export default function Runs() {

    const navigate = useNavigate();

    const [jobRuns, setJobRuns] = useState<Array<JobRunDto> | null>(null);

    const [listToRefresh, setListToRefresh] = useState<boolean>(false);

    function onRunClick(jobId: number, pathId: number, pathTypeId: number): void {
        switch (pathTypeId) {
            case PathType.DataSynchronization:
                navigate("/" + PathSynchroRoute + "/" + pathId);
                break;
            case PathType.Reporting:
                navigate("/" + PathReportingRoute + "/" + pathId);
                break;
            case PathType.DataTable:
                navigate("/" + PathDataTableRoute + "/" + pathId);
                break;
            case PathType.MetaApi:
                navigate("/" + PathMetaApiRoute + "/" + pathId);
                break;
            case PathType.AI:
                navigate("/" + PathAIRoute + "/" + pathId);
                break;
            default:
        }
    }
    
    const refresh = useCallback(() => {
        if (!jobRuns || listToRefresh) {
            JobApi.GetRunListAsync(null, null).then((allJobRuns: any) => {
                if (allJobRuns.IsFailed()) {
                    // TODO: Handle failure case (e.g., logout)
                } else {
                    setJobRuns(allJobRuns.Result);
                    setListToRefresh(false);
                }
            });
        }
    }, [jobRuns, listToRefresh]);

    // UseEffect to refresh when component mounts
    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <React.Fragment>
            <div className="runs-container">
                <div className={"runs-internal-container"}>
                    <div className={"runs-title-container"}>
                        <h2>{"Your 500 last runs"}</h2>
                    </div>
                    <RunGrid jobRuns={jobRuns} OnClick={onRunClick} />
                </div>
            </div>
        </React.Fragment >
    );
}